<template>
  <div>
    <h1 class="text-center font-extrabold text-xl">Nouvelle entit&eacute; de facturation</h1>
    <BillingEntityForm v-model="billingEntity" :stores="stores" :showIban="true" @submit="submit" />
  </div>
</template>

<script>
import BillingEntityForm from "@/components/billing_entities/BillingEntityForm.vue";
import { mapActions } from "vuex";

export default {
  components: {
    BillingEntityForm,
  },
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    stores: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["success"],
  data() {
    return {
      billingEntity: {
        name: null,
        businessName: null,
        billingAddress: null,
        iban: null,
        storeIds: [],
      },
    };
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("billingEntities", ["create"]),

    async submit() {
      const result = await this.create({
        organizationId: this.organizationId,
        ...this.billingEntity,
      });
      if (!result) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Entit\u00e9 de facturation cr\u00e9\u00e9e",
      });
      this.$emit("success");
    },
  },
};
</script>
